// extracted by mini-css-extract-plugin
export default {"selector":"Selector_selector__tmjDS","is_active":"Selector_is_active__DWcJA","h5_title":"Selector_h5_title__aQp6U"};